import { Component } from '@angular/core';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpSectionCode } from '../../../services/http/wordpress/wordpress.interface';
import { CommonModule } from '@angular/common';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent {
  privacyText = '';
  title = "";
  description = "";
  image = "";

  constructor(
    private readonly wordpressService: WordpressService
  ) {
    this.wordpressService.getPost({section: WpSectionCode.privacy, client: WpClientCode.genCat}).subscribe((response) => {
      this.privacyText = response?.content.rendered || '';
      this.title = response?.title.rendered || '';
      this.image = response?.acf.image_url || '';
    });
  }
}
